import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "o-form" }
const _hoisted_2 = {
  key: 0,
  class: "u-bg-color-white o-box"
}
const _hoisted_3 = { class: "o-box__content" }
const _hoisted_4 = {
  key: 0,
  class: "u-bg-color-white o-box"
}
const _hoisted_5 = { class: "o-box__content" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "o-title-4 u-mb-xs" }, "Vos informations", -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "o-text u-mb-xs" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Veuillez noter que nous n’acceptons pas d’événements à caractère festif tel que des réceptions ou fêtes.")
], -1 /* HOISTED */)
const _hoisted_8 = { class: "o-grid -x-sm -y-sm" }
const _hoisted_9 = { class: "o-grid-6" }
const _hoisted_10 = { class: "o-form__group" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "o-label",
  for: "organisation"
}, "Organisation *", -1 /* HOISTED */)
const _hoisted_12 = { class: "o-grid-6" }
const _hoisted_13 = { class: "o-form__group" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  class: "o-label",
  for: "facture"
}, "Facture à", -1 /* HOISTED */)
const _hoisted_15 = { class: "o-grid-6" }
const _hoisted_16 = { class: "o-form__group" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  class: "o-label",
  for: "personne-ress"
}, "Personne ressource *", -1 /* HOISTED */)
const _hoisted_18 = { class: "o-grid-6" }
const _hoisted_19 = { class: "o-form__group" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  class: "o-label",
  for: "courriel"
}, "Courriel *", -1 /* HOISTED */)
const _hoisted_21 = { class: "o-grid-6" }
const _hoisted_22 = { class: "o-form__group -form-group-flex" }
const _hoisted_23 = { class: "o-form__group__item" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", {
  class: "o-label",
  for: "telephone"
}, "Téléphone *", -1 /* HOISTED */)
const _hoisted_25 = { class: "o-form__group__item" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  class: "o-label",
  for: "poste"
}, "Poste", -1 /* HOISTED */)
const _hoisted_27 = { class: "o-grid-6" }
const _hoisted_28 = { class: "o-form__group" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", {
  class: "o-label",
  for: "cellulaire"
}, "Cellulaire", -1 /* HOISTED */)
const _hoisted_30 = { class: "o-grid-12" }
const _hoisted_31 = { class: "o-form__group" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", {
  class: "o-label",
  for: "adresse"
}, "Adresse *", -1 /* HOISTED */)
const _hoisted_33 = { class: "o-grid-6" }
const _hoisted_34 = { class: "o-form__group" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", {
  class: "o-label",
  for: "ville"
}, "Ville *", -1 /* HOISTED */)
const _hoisted_36 = { class: "o-grid-6" }
const _hoisted_37 = { class: "o-form__group" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", {
  class: "o-label",
  for: "province"
}, "Province *", -1 /* HOISTED */)
const _hoisted_39 = { class: "o-grid-6" }
const _hoisted_40 = { class: "o-form__group" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", {
  class: "o-label",
  for: "code-postal"
}, "Code postal *", -1 /* HOISTED */)
const _hoisted_42 = { class: "o-grid-6" }
const _hoisted_43 = { class: "o-form__group" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", {
  class: "o-label",
  for: "numero-client"
}, "Numéro de client", -1 /* HOISTED */)
const _hoisted_45 = { class: "o-grid-12" }
const _hoisted_46 = { class: "o-form__group o-checkbox__group u-mt-xs" }
const _hoisted_47 = { class: "o-checkbox__wrap" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", {
  class: "o-checkbox-label",
  for: "choix-1"
}, " J'ai un numéro de client, mais il y a changement d'adresse ", -1 /* HOISTED */)
const _hoisted_49 = { class: "o-checkbox__wrap" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", {
  class: "o-checkbox-label",
  for: "choix-2"
}, " Je suis un nouveau client du Centre St-Pierre. ", -1 /* HOISTED */)
const _hoisted_51 = { class: "o-title-cta u-mb-xs u-mt-md" }
const _hoisted_52 = { class: "o-title-4" }
const _hoisted_53 = {
  key: 0,
  class: "o-title-cta__link"
}
const _hoisted_54 = { class: "o-button-reset -button-reset-flipped" }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = { class: "o-grid -x-sm -y-sm" }
const _hoisted_57 = { class: "o-grid-12" }
const _hoisted_58 = { class: "o-form__group" }
const _hoisted_59 = ["id", "onUpdate:modelValue"]
const _hoisted_60 = ["for"]
const _hoisted_61 = { class: "o-grid-4" }
const _hoisted_62 = { class: "o-form__group" }
const _hoisted_63 = ["id", "onUpdate:modelValue"]
const _hoisted_64 = ["for"]
const _hoisted_65 = { class: "o-grid-4" }
const _hoisted_66 = { class: "o-form__group" }
const _hoisted_67 = ["id", "onUpdate:modelValue"]
const _hoisted_68 = ["for"]
const _hoisted_69 = { class: "o-grid-4" }
const _hoisted_70 = { class: "o-form__group" }
const _hoisted_71 = ["id", "onUpdate:modelValue"]
const _hoisted_72 = ["for"]
const _hoisted_73 = { class: "o-grid-4" }
const _hoisted_74 = { class: "o-form__group" }
const _hoisted_75 = ["id", "onUpdate:modelValue"]
const _hoisted_76 = ["for"]
const _hoisted_77 = { class: "o-grid-6" }
const _hoisted_78 = { class: "o-form__group" }
const _hoisted_79 = ["for"]
const _hoisted_80 = { class: "o-select__wrap" }
const _hoisted_81 = ["id", "onUpdate:modelValue"]
const _hoisted_82 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Type d'activité", -1 /* HOISTED */)
const _hoisted_83 = ["value"]
const _hoisted_84 = { class: "o-grid-6" }
const _hoisted_85 = { class: "o-form__group" }
const _hoisted_86 = ["for"]
const _hoisted_87 = { class: "o-select__wrap" }
const _hoisted_88 = ["id", "onUpdate:modelValue"]
const _hoisted_89 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Salle", -1 /* HOISTED */)
const _hoisted_90 = ["value", "innerHTML"]
const _hoisted_91 = {
  key: 0,
  class: "u-mt-xs"
}
const _hoisted_92 = /*#__PURE__*/_createElementVNode("strong", null, "Veuillez noter que cette salle est non accessible aux personnes à mobilité réduite.", -1 /* HOISTED */)
const _hoisted_93 = [
  _hoisted_92
]
const _hoisted_94 = {
  key: 0,
  class: "o-box-infos__configs__wrap u-py-md u-bdb-color-4-30"
}
const _hoisted_95 = /*#__PURE__*/_createElementVNode("div", { class: "o-title-5 u-mb-xs o-box-infos__configs__title" }, " Configuration ", -1 /* HOISTED */)
const _hoisted_96 = { class: "o-box-infos__configs" }
const _hoisted_97 = {
  key: 0,
  class: "o-box-infos__configs__item"
}
const _hoisted_98 = { class: "o-radio__wrap -radio-col" }
const _hoisted_99 = ["onUpdate:modelValue", "id"]
const _hoisted_100 = ["for"]
const _hoisted_101 = { class: "o-box-infos__configs__ico" }
const _hoisted_102 = {
  key: 1,
  class: "o-box-infos__configs__item"
}
const _hoisted_103 = { class: "o-radio__wrap -radio-col" }
const _hoisted_104 = ["onUpdate:modelValue", "id"]
const _hoisted_105 = ["for"]
const _hoisted_106 = { class: "o-box-infos__configs__ico" }
const _hoisted_107 = {
  key: 2,
  class: "o-box-infos__configs__item"
}
const _hoisted_108 = { class: "o-radio__wrap -radio-col" }
const _hoisted_109 = ["onUpdate:modelValue", "id"]
const _hoisted_110 = ["for"]
const _hoisted_111 = { class: "o-box-infos__configs__ico" }
const _hoisted_112 = {
  key: 3,
  class: "o-box-infos__configs__item"
}
const _hoisted_113 = { class: "o-radio__wrap -radio-col" }
const _hoisted_114 = ["onUpdate:modelValue", "id"]
const _hoisted_115 = ["for"]
const _hoisted_116 = { class: "o-box-infos__configs__ico" }
const _hoisted_117 = {
  key: 4,
  class: "o-box-infos__configs__item"
}
const _hoisted_118 = { class: "o-radio__wrap -radio-col" }
const _hoisted_119 = ["onUpdate:modelValue", "id"]
const _hoisted_120 = ["for"]
const _hoisted_121 = { class: "o-box-infos__configs__ico" }
const _hoisted_122 = {
  key: 5,
  class: "o-box-infos__configs__item"
}
const _hoisted_123 = { class: "o-radio__wrap -radio-col" }
const _hoisted_124 = ["onUpdate:modelValue", "id"]
const _hoisted_125 = ["for"]
const _hoisted_126 = { class: "o-box-infos__configs__ico" }
const _hoisted_127 = { class: "o-form__group u-mt-md" }
const _hoisted_128 = ["id", "onUpdate:modelValue"]
const _hoisted_129 = ["for"]
const _hoisted_130 = /*#__PURE__*/_createElementVNode("div", { class: "o-title-5 u-mt-md u-mb-xs" }, " Équipements et breuvages ", -1 /* HOISTED */)
const _hoisted_131 = { class: "o-form__group -form-group-flex" }
const _hoisted_132 = { class: "o-form__group__item" }
const _hoisted_133 = ["for"]
const _hoisted_134 = { class: "o-select__wrap" }
const _hoisted_135 = ["id", "onUpdate:modelValue"]
const _hoisted_136 = ["label"]
const _hoisted_137 = ["value"]
const _hoisted_138 = { class: "o-form__group__item" }
const _hoisted_139 = { class: "o-button__wrap" }
const _hoisted_140 = ["onClick"]
const _hoisted_141 = /*#__PURE__*/_createElementVNode("span", { class: "o-button__text" }, "Ajouter", -1 /* HOISTED */)
const _hoisted_142 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  class: "o-ico -ico-plus"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/app/themes/baserock/assets/img/sprite.svg?v=444da4f220674cbd9d#close" })
], -1 /* HOISTED */)
const _hoisted_143 = [
  _hoisted_141,
  _hoisted_142
]
const _hoisted_144 = { class: "o-grid -x-sm -y-sm u-mt-xs" }
const _hoisted_145 = { class: "o-grid-4 -grid-middle" }
const _hoisted_146 = { class: "o-grid-8" }
const _hoisted_147 = { class: "o-grid -x-sm -y-sm" }
const _hoisted_148 = { class: "o-grid-6" }
const _hoisted_149 = { class: "o-form__group" }
const _hoisted_150 = { class: "o-form__group__item" }
const _hoisted_151 = ["id", "onUpdate:modelValue"]
const _hoisted_152 = ["for"]
const _hoisted_153 = { class: "o-grid-6" }
const _hoisted_154 = { class: "o-form__group -form-group-flex" }
const _hoisted_155 = { class: "o-form__group__item" }
const _hoisted_156 = ["id", "onUpdate:modelValue"]
const _hoisted_157 = ["for"]
const _hoisted_158 = { class: "o-form__group__item" }
const _hoisted_159 = { class: "o-button__wrap" }
const _hoisted_160 = ["onClick"]
const _hoisted_161 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  class: "o-ico -ico-trash"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/app/themes/baserock/assets/img/sprite.svg?v=444da4f220674cbd9d#trash" })
], -1 /* HOISTED */)
const _hoisted_162 = [
  _hoisted_161
]
const _hoisted_163 = { class: "u-mt-md" }
const _hoisted_164 = { class: "o-form__group o-checkbox__group" }
const _hoisted_165 = { class: "o-checkbox__wrap" }
const _hoisted_166 = /*#__PURE__*/_createElementVNode("label", {
  class: "o-checkbox-label",
  for: "choix-5"
}, " Je reconnais avoir lu, compris et accepté les politiques du service de location de salles du Centre St-Pierre. ", -1 /* HOISTED */)
const _hoisted_167 = {
  key: 1,
  class: "o-button__wrap -button-center -button-full-mb u-my-lg"
}
const _hoisted_168 = /*#__PURE__*/_createElementVNode("span", { class: "o-button__text" }, "Ajouter une réservation", -1 /* HOISTED */)
const _hoisted_169 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  class: "o-ico -ico-plus"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/app/themes/baserock/assets/img/sprite.svg?v=444da4f220674cbd9d#close" })
], -1 /* HOISTED */)
const _hoisted_170 = [
  _hoisted_168,
  _hoisted_169
]
const _hoisted_171 = /*#__PURE__*/_createElementVNode("span", { class: "o-button__text" }, "Envoyer", -1 /* HOISTED */)
const _hoisted_172 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Soumettre le formulaire", -1 /* HOISTED */)
const _hoisted_173 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  class: "o-ico -ico-send"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/app/themes/baserock/assets/img/sprite.svg?v=444da4f220674cbd9d#send" })
], -1 /* HOISTED */)
const _hoisted_174 = [
  _hoisted_171,
  _hoisted_172,
  _hoisted_173
]
const _hoisted_175 = {
  key: 0,
  id: "successmessage",
  class: "o-form__message u-mb-lg"
}
const _hoisted_176 = /*#__PURE__*/_createElementVNode("h3", { class: "o-title-3 u-mb-xs" }, "Nous avons bien reçu votre demande", -1 /* HOISTED */)
const _hoisted_177 = /*#__PURE__*/_createElementVNode("div", { class: "o-text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Merci pour votre réservation, nous vous contacterons sous peu.")
], -1 /* HOISTED */)
const _hoisted_178 = [
  _hoisted_176,
  _hoisted_177
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Spinner = _resolveComponent("Spinner")
  const _component_Image = _resolveComponent("Image")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", _hoisted_1, [
      ($data.isSubmitting)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_Spinner)
            ])
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (!$data.success)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("fieldset", null, [
                      _hoisted_6,
                      _hoisted_7,
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _withDirectives(_createElementVNode("input", {
                              class: "o-input",
                              type: "text",
                              id: "organisation",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.formData.organisation) = $event)),
                              placeholder: "",
                              required: ""
                            }, null, 512 /* NEED_PATCH */), [
                              [_vModelText, $data.formData.organisation]
                            ]),
                            _hoisted_11
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _withDirectives(_createElementVNode("input", {
                              class: "o-input",
                              type: "text",
                              id: "facture",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.formData.facture) = $event)),
                              placeholder: ""
                            }, null, 512 /* NEED_PATCH */), [
                              [_vModelText, $data.formData.facture]
                            ]),
                            _hoisted_14
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _withDirectives(_createElementVNode("input", {
                              class: "o-input",
                              type: "text",
                              id: "personne-ress",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.formData.personneRessource) = $event)),
                              placeholder: "",
                              required: ""
                            }, null, 512 /* NEED_PATCH */), [
                              [_vModelText, $data.formData.personneRessource]
                            ]),
                            _hoisted_17
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _withDirectives(_createElementVNode("input", {
                              class: "o-input",
                              type: "email",
                              id: "courriel",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.formData.courriel) = $event)),
                              placeholder: "",
                              required: ""
                            }, null, 512 /* NEED_PATCH */), [
                              [_vModelText, $data.formData.courriel]
                            ]),
                            _hoisted_20
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              _withDirectives(_createElementVNode("input", {
                                class: "o-input",
                                type: "text",
                                id: "telephone",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.formData.telephone) = $event)),
                                placeholder: "",
                                required: ""
                              }, null, 512 /* NEED_PATCH */), [
                                [_vModelText, $data.formData.telephone]
                              ]),
                              _hoisted_24
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                              _withDirectives(_createElementVNode("input", {
                                class: "o-input -input-maxw",
                                type: "text",
                                id: "poste",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($data.formData.poste) = $event)),
                                placeholder: ""
                              }, null, 512 /* NEED_PATCH */), [
                                [_vModelText, $data.formData.poste]
                              ]),
                              _hoisted_26
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _withDirectives(_createElementVNode("input", {
                              class: "o-input",
                              type: "text",
                              id: "cellulaire",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($data.formData.cellulaire) = $event)),
                              placeholder: ""
                            }, null, 512 /* NEED_PATCH */), [
                              [_vModelText, $data.formData.cellulaire]
                            ]),
                            _hoisted_29
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _withDirectives(_createElementVNode("input", {
                              class: "o-input",
                              type: "text",
                              id: "adresse",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($data.formData.adresse) = $event)),
                              placeholder: "",
                              required: ""
                            }, null, 512 /* NEED_PATCH */), [
                              [_vModelText, $data.formData.adresse]
                            ]),
                            _hoisted_32
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, [
                            _withDirectives(_createElementVNode("input", {
                              class: "o-input",
                              type: "text",
                              id: "ville",
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($data.formData.ville) = $event)),
                              placeholder: "",
                              required: ""
                            }, null, 512 /* NEED_PATCH */), [
                              [_vModelText, $data.formData.ville]
                            ]),
                            _hoisted_35
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, [
                            _withDirectives(_createElementVNode("input", {
                              class: "o-input",
                              type: "text",
                              id: "province",
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (($data.formData.province) = $event)),
                              placeholder: "",
                              required: ""
                            }, null, 512 /* NEED_PATCH */), [
                              [_vModelText, $data.formData.province]
                            ]),
                            _hoisted_38
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _withDirectives(_createElementVNode("input", {
                              class: "o-input",
                              type: "text",
                              id: "code-postal",
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (($data.formData.codePostal) = $event)),
                              placeholder: "",
                              required: ""
                            }, null, 512 /* NEED_PATCH */), [
                              [_vModelText, $data.formData.codePostal]
                            ]),
                            _hoisted_41
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("div", _hoisted_43, [
                            _withDirectives(_createElementVNode("input", {
                              class: "o-input",
                              type: "text",
                              id: "numero-client",
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => (($data.formData.numeroClient) = $event)),
                              placeholder: ""
                            }, null, 512 /* NEED_PATCH */), [
                              [_vModelText, $data.formData.numeroClient]
                            ]),
                            _hoisted_44
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("div", _hoisted_47, [
                              _withDirectives(_createElementVNode("input", {
                                class: "o-checkbox",
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => (($data.formData.changementAdresse) = $event)),
                                id: "choix-1",
                                value: "1"
                              }, null, 512 /* NEED_PATCH */), [
                                [_vModelCheckbox, $data.formData.changementAdresse]
                              ]),
                              _hoisted_48
                            ]),
                            _createElementVNode("div", _hoisted_49, [
                              _withDirectives(_createElementVNode("input", {
                                class: "o-checkbox",
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => (($data.formData.nouveauClient) = $event)),
                                id: "choix-2",
                                value: "1"
                              }, null, 512 /* NEED_PATCH */), [
                                [_vModelCheckbox, $data.formData.nouveauClient]
                              ]),
                              _hoisted_50
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("fieldset", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.formData.reservations, (reservation, frmIndex) => {
                        return (_openBlock(), _createElementBlock("div", null, [
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("h4", _hoisted_52, " Réservation No. " + _toDisplayString(frmIndex+1), 1 /* TEXT */),
                            (frmIndex>0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                  _createElementVNode("div", _hoisted_54, [
                                    _createElementVNode("input", {
                                      onClick: _withModifiers($event => ($options.removeReservation(frmIndex)), ["prevent"]),
                                      type: "button",
                                      value: "Supprimer"
                                    }, null, 8 /* PROPS */, _hoisted_55),
                                    _createVNode(_component_Image, {
                                      id: "trash",
                                      class: "-ico-trash"
                                    })
                                  ])
                                ]))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _createElementVNode("div", _hoisted_56, [
                            _createElementVNode("div", _hoisted_57, [
                              _createElementVNode("div", _hoisted_58, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "o-input",
                                  type: "text",
                                  id: 'nom-reservation'+frmIndex,
                                  "onUpdate:modelValue": $event => (($data.formData.reservations[frmIndex].titreReservation) = $event),
                                  placeholder: "",
                                  required: ""
                                }, null, 8 /* PROPS */, _hoisted_59), [
                                  [_vModelText, $data.formData.reservations[frmIndex].titreReservation]
                                ]),
                                _createElementVNode("label", {
                                  class: "o-label",
                                  for: 'nom-reservation'+frmIndex
                                }, "Titre de votre réservation/activité *", 8 /* PROPS */, _hoisted_60)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_61, [
                              _createElementVNode("div", _hoisted_62, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "o-input",
                                  type: "number",
                                  id: 'nombre-personne'+frmIndex,
                                  "onUpdate:modelValue": $event => (($data.formData.reservations[frmIndex].nombrePersonne) = $event),
                                  placeholder: "",
                                  required: ""
                                }, null, 8 /* PROPS */, _hoisted_63), [
                                  [_vModelText, $data.formData.reservations[frmIndex].nombrePersonne]
                                ]),
                                _createElementVNode("label", {
                                  class: "o-label",
                                  for: 'nombre-personne'+frmIndex
                                }, "Nombre de personne *", 8 /* PROPS */, _hoisted_64)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_65, [
                              _createElementVNode("div", _hoisted_66, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "o-input",
                                  type: "date",
                                  id: 'date'+frmIndex,
                                  "onUpdate:modelValue": $event => (($data.formData.reservations[frmIndex].date) = $event),
                                  placeholder: "",
                                  required: ""
                                }, null, 8 /* PROPS */, _hoisted_67), [
                                  [_vModelText, $data.formData.reservations[frmIndex].date]
                                ]),
                                _createElementVNode("label", {
                                  class: "o-label",
                                  for: 'date'+frmIndex
                                }, "Date *", 8 /* PROPS */, _hoisted_68)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_69, [
                              _createElementVNode("div", _hoisted_70, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "o-input",
                                  type: "text",
                                  id: 'heureDebut'+frmIndex,
                                  "onUpdate:modelValue": $event => (($data.formData.reservations[frmIndex].heureDebut) = $event),
                                  placeholder: "",
                                  required: ""
                                }, null, 8 /* PROPS */, _hoisted_71), [
                                  [_vModelText, $data.formData.reservations[frmIndex].heureDebut]
                                ]),
                                _createElementVNode("label", {
                                  class: "o-label",
                                  for: 'heureDebut'+frmIndex
                                }, "Heure début *", 8 /* PROPS */, _hoisted_72)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_73, [
                              _createElementVNode("div", _hoisted_74, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "o-input",
                                  type: "text",
                                  id: 'heureFin'+frmIndex,
                                  "onUpdate:modelValue": $event => (($data.formData.reservations[frmIndex].heureFin) = $event),
                                  placeholder: "",
                                  required: ""
                                }, null, 8 /* PROPS */, _hoisted_75), [
                                  [_vModelText, $data.formData.reservations[frmIndex].heureFin]
                                ]),
                                _createElementVNode("label", {
                                  class: "o-label",
                                  for: 'heureFin'+frmIndex
                                }, "Heure fin *", 8 /* PROPS */, _hoisted_76)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_77, [
                              _createElementVNode("div", _hoisted_78, [
                                _createElementVNode("label", {
                                  class: "sr-only",
                                  for: 'type-activite'+frmIndex
                                }, "Type d'activité", 8 /* PROPS */, _hoisted_79),
                                _createElementVNode("div", _hoisted_80, [
                                  _withDirectives(_createElementVNode("select", {
                                    class: "o-select",
                                    id: 'type-activite'+frmIndex,
                                    "onUpdate:modelValue": $event => (($data.formData.reservations[frmIndex].typeActivite) = $event)
                                  }, [
                                    _hoisted_82,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.typesActivite, (ta) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        value: ta.type
                                      }, _toDisplayString(ta.type), 9 /* TEXT, PROPS */, _hoisted_83))
                                    }), 256 /* UNKEYED_FRAGMENT */))
                                  ], 8 /* PROPS */, _hoisted_81), [
                                    [_vModelSelect, $data.formData.reservations[frmIndex].typeActivite]
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_84, [
                              _createElementVNode("div", _hoisted_85, [
                                _createElementVNode("label", {
                                  class: "sr-only",
                                  for: 'salle'+frmIndex
                                }, "Salle", 8 /* PROPS */, _hoisted_86),
                                _createElementVNode("div", _hoisted_87, [
                                  _withDirectives(_createElementVNode("select", {
                                    class: "o-select",
                                    id: 'salle'+frmIndex,
                                    "onUpdate:modelValue": $event => (($data.formData.reservations[frmIndex].salle) = $event)
                                  }, [
                                    _hoisted_89,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.salles, (salle) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        value: salle.titre,
                                        innerHTML: salle.numero + salle.titre
                                      }, null, 8 /* PROPS */, _hoisted_90))
                                    }), 256 /* UNKEYED_FRAGMENT */))
                                  ], 8 /* PROPS */, _hoisted_88), [
                                    [_vModelSelect, $data.formData.reservations[frmIndex].salle]
                                  ])
                                ]),
                                ($data.formData.reservations[frmIndex].salle && !$options.hasMobilite($data.formData.reservations[frmIndex].salle))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_91, _hoisted_93))
                                  : _createCommentVNode("v-if", true)
                              ])
                            ])
                          ]),
                          ($data.formData.reservations[frmIndex].salle)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                                _hoisted_95,
                                _createElementVNode("div", _hoisted_96, [
                                  ($props.salles.find(s => s.titre == $data.formData.reservations[frmIndex].salle).configurations.find(c => c.configuration == 'theatre'))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                                        _createElementVNode("div", _hoisted_98, [
                                          _withDirectives(_createElementVNode("input", {
                                            class: "o-radio",
                                            type: "radio",
                                            "onUpdate:modelValue": $event => (($data.formData.reservations[frmIndex].configuration) = $event),
                                            id: 'choix-radio-'+frmIndex+'t',
                                            value: "Théâtre",
                                            required: ""
                                          }, null, 8 /* PROPS */, _hoisted_99), [
                                            [_vModelRadio, $data.formData.reservations[frmIndex].configuration]
                                          ]),
                                          _createElementVNode("label", {
                                            class: "o-radio-label",
                                            for: 'choix-radio-'+frmIndex+'t'
                                          }, [
                                            _createTextVNode(" Théâtre "),
                                            _createElementVNode("div", _hoisted_101, [
                                              _createVNode(_component_Image, {
                                                id: "salle-theatre",
                                                class: "-ico-salle"
                                              })
                                            ])
                                          ], 8 /* PROPS */, _hoisted_100)
                                        ])
                                      ]))
                                    : _createCommentVNode("v-if", true),
                                  ($props.salles.find(s => s.titre == $data.formData.reservations[frmIndex].salle).configurations.find(c => c.configuration == 'u'))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                                        _createElementVNode("div", _hoisted_103, [
                                          _withDirectives(_createElementVNode("input", {
                                            class: "o-radio",
                                            type: "radio",
                                            "onUpdate:modelValue": $event => (($data.formData.reservations[frmIndex].configuration) = $event),
                                            id: 'choix-radio-'+frmIndex+'u',
                                            value: "U",
                                            required: ""
                                          }, null, 8 /* PROPS */, _hoisted_104), [
                                            [_vModelRadio, $data.formData.reservations[frmIndex].configuration]
                                          ]),
                                          _createElementVNode("label", {
                                            class: "o-radio-label",
                                            for: 'choix-radio-'+frmIndex+'u'
                                          }, [
                                            _createTextVNode(" U "),
                                            _createElementVNode("div", _hoisted_106, [
                                              _createVNode(_component_Image, {
                                                id: "salle-u",
                                                class: "-ico-salle"
                                              })
                                            ])
                                          ], 8 /* PROPS */, _hoisted_105)
                                        ])
                                      ]))
                                    : _createCommentVNode("v-if", true),
                                  ($props.salles.find(s => s.titre == $data.formData.reservations[frmIndex].salle).configurations.find(c => c.configuration == 'cercle'))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                                        _createElementVNode("div", _hoisted_108, [
                                          _withDirectives(_createElementVNode("input", {
                                            class: "o-radio",
                                            type: "radio",
                                            "onUpdate:modelValue": $event => (($data.formData.reservations[frmIndex].configuration) = $event),
                                            id: 'choix-radio-'+frmIndex+'c',
                                            value: "Cercle",
                                            required: ""
                                          }, null, 8 /* PROPS */, _hoisted_109), [
                                            [_vModelRadio, $data.formData.reservations[frmIndex].configuration]
                                          ]),
                                          _createElementVNode("label", {
                                            class: "o-radio-label",
                                            for: 'choix-radio-'+frmIndex+'c'
                                          }, [
                                            _createTextVNode(" Cercle "),
                                            _createElementVNode("div", _hoisted_111, [
                                              _createVNode(_component_Image, {
                                                id: "salle-cercle",
                                                class: "-ico-salle"
                                              })
                                            ])
                                          ], 8 /* PROPS */, _hoisted_110)
                                        ])
                                      ]))
                                    : _createCommentVNode("v-if", true),
                                  ($props.salles.find(s => s.titre == $data.formData.reservations[frmIndex].salle).configurations.find(c => c.configuration == 'ecole'))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                                        _createElementVNode("div", _hoisted_113, [
                                          _withDirectives(_createElementVNode("input", {
                                            class: "o-radio",
                                            type: "radio",
                                            "onUpdate:modelValue": $event => (($data.formData.reservations[frmIndex].configuration) = $event),
                                            id: 'choix-radio-'+frmIndex+'eco',
                                            value: "École",
                                            required: ""
                                          }, null, 8 /* PROPS */, _hoisted_114), [
                                            [_vModelRadio, $data.formData.reservations[frmIndex].configuration]
                                          ]),
                                          _createElementVNode("label", {
                                            class: "o-radio-label",
                                            for: 'choix-radio-'+frmIndex+'eco'
                                          }, [
                                            _createTextVNode(" École "),
                                            _createElementVNode("div", _hoisted_116, [
                                              _createVNode(_component_Image, {
                                                id: "salle-ecole",
                                                class: "-ico-salle"
                                              })
                                            ])
                                          ], 8 /* PROPS */, _hoisted_115)
                                        ])
                                      ]))
                                    : _createCommentVNode("v-if", true),
                                  ($props.salles.find(s => s.titre == $data.formData.reservations[frmIndex].salle).configurations.find(c => c.configuration == 'reunion'))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                                        _createElementVNode("div", _hoisted_118, [
                                          _withDirectives(_createElementVNode("input", {
                                            class: "o-radio",
                                            type: "radio",
                                            "onUpdate:modelValue": $event => (($data.formData.reservations[frmIndex].configuration) = $event),
                                            id: 'choix-radio-'+frmIndex+'reu',
                                            value: "Réunion",
                                            required: ""
                                          }, null, 8 /* PROPS */, _hoisted_119), [
                                            [_vModelRadio, $data.formData.reservations[frmIndex].configuration]
                                          ]),
                                          _createElementVNode("label", {
                                            class: "o-radio-label",
                                            for: 'choix-radio-'+frmIndex+'reu'
                                          }, [
                                            _createTextVNode(" Réunion "),
                                            _createElementVNode("div", _hoisted_121, [
                                              _createVNode(_component_Image, {
                                                id: "salle-reunion",
                                                class: "-ico-salle"
                                              })
                                            ])
                                          ], 8 /* PROPS */, _hoisted_120)
                                        ])
                                      ]))
                                    : _createCommentVNode("v-if", true),
                                  ($props.salles.find(s => s.titre == $data.formData.reservations[frmIndex].salle).configurations.find(c => c.configuration == 'ilots'))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                                        _createElementVNode("div", _hoisted_123, [
                                          _withDirectives(_createElementVNode("input", {
                                            class: "o-radio",
                                            type: "radio",
                                            "onUpdate:modelValue": $event => (($data.formData.reservations[frmIndex].configuration) = $event),
                                            id: 'choix-radio-'+frmIndex+'ilo',
                                            value: "Îlots",
                                            required: ""
                                          }, null, 8 /* PROPS */, _hoisted_124), [
                                            [_vModelRadio, $data.formData.reservations[frmIndex].configuration]
                                          ]),
                                          _createElementVNode("label", {
                                            class: "o-radio-label",
                                            for: 'choix-radio-'+frmIndex+'ilo'
                                          }, [
                                            _createTextVNode(" Ilots "),
                                            _createElementVNode("div", _hoisted_126, [
                                              _createVNode(_component_Image, {
                                                id: "salle-ilots",
                                                class: "-ico-salle"
                                              })
                                            ])
                                          ], 8 /* PROPS */, _hoisted_125)
                                        ])
                                      ]))
                                    : _createCommentVNode("v-if", true)
                                ])
                              ]))
                            : _createCommentVNode("v-if", true),
                          _createElementVNode("div", _hoisted_127, [
                            _withDirectives(_createElementVNode("textarea", {
                              class: "o-textarea",
                              id: 'notes'+frmIndex,
                              "onUpdate:modelValue": $event => (($data.formData.reservations[frmIndex].note) = $event),
                              placeholder: ""
                            }, null, 8 /* PROPS */, _hoisted_128), [
                              [_vModelText, $data.formData.reservations[frmIndex].note]
                            ]),
                            _createElementVNode("label", {
                              class: "o-label",
                              for: 'notes'+frmIndex
                            }, "Notes", 8 /* PROPS */, _hoisted_129)
                          ]),
                          _hoisted_130,
                          _createElementVNode("div", _hoisted_131, [
                            _createElementVNode("div", _hoisted_132, [
                              _createElementVNode("label", {
                                class: "sr-only",
                                for: 'options'+frmIndex
                              }, "Options", 8 /* PROPS */, _hoisted_133),
                              _createElementVNode("div", _hoisted_134, [
                                _withDirectives(_createElementVNode("select", {
                                  class: "o-select",
                                  id: 'options'+frmIndex,
                                  "onUpdate:modelValue": $event => (($data.formData.reservations[frmIndex]._selectedOption) = $event)
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (group) => {
                                    return (_openBlock(), _createElementBlock("optgroup", {
                                      label: group.groupe
                                    }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (opt) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          value: opt.option
                                        }, _toDisplayString(opt.option), 9 /* TEXT, PROPS */, _hoisted_137))
                                      }), 256 /* UNKEYED_FRAGMENT */))
                                    ], 8 /* PROPS */, _hoisted_136))
                                  }), 256 /* UNKEYED_FRAGMENT */))
                                ], 8 /* PROPS */, _hoisted_135), [
                                  [_vModelSelect, $data.formData.reservations[frmIndex]._selectedOption]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_138, [
                              _createElementVNode("div", _hoisted_139, [
                                _createElementVNode("span", {
                                  onClick: $event => ($options.addOption(frmIndex)),
                                  class: "o-button"
                                }, _hoisted_143, 8 /* PROPS */, _hoisted_140)
                              ])
                            ])
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reservation.options, (opt, optIndex) => {
                            return (_openBlock(), _createElementBlock("div", _hoisted_144, [
                              _createElementVNode("div", _hoisted_145, _toDisplayString(opt.option), 1 /* TEXT */),
                              _createElementVNode("div", _hoisted_146, [
                                _createElementVNode("div", _hoisted_147, [
                                  _createElementVNode("div", _hoisted_148, [
                                    _createElementVNode("div", _hoisted_149, [
                                      _createElementVNode("div", _hoisted_150, [
                                        _withDirectives(_createElementVNode("input", {
                                          class: "o-input",
                                          type: "text",
                                          id: 'heure-service-items'+frmIndex+'-'+optIndex,
                                          "onUpdate:modelValue": $event => (($data.formData.reservations[frmIndex].options[optIndex].service) = $event),
                                          placeholder: ""
                                        }, null, 8 /* PROPS */, _hoisted_151), [
                                          [_vModelText, $data.formData.reservations[frmIndex].options[optIndex].service]
                                        ]),
                                        _createElementVNode("label", {
                                          class: "o-label",
                                          for: 'heure-service-items'+frmIndex+'-'+optIndex
                                        }, "Heure de service", 8 /* PROPS */, _hoisted_152)
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_153, [
                                    _createElementVNode("div", _hoisted_154, [
                                      _createElementVNode("div", _hoisted_155, [
                                        _withDirectives(_createElementVNode("input", {
                                          class: "o-input",
                                          type: "text",
                                          id: 'nombre-items'+frmIndex+'-'+optIndex,
                                          "onUpdate:modelValue": $event => (($data.formData.reservations[frmIndex].options[optIndex].quantite) = $event),
                                          placeholder: ""
                                        }, null, 8 /* PROPS */, _hoisted_156), [
                                          [_vModelText, $data.formData.reservations[frmIndex].options[optIndex].quantite]
                                        ]),
                                        _createElementVNode("label", {
                                          class: "o-label",
                                          for: 'nombre-items'+frmIndex+'-'+optIndex
                                        }, "Quantité", 8 /* PROPS */, _hoisted_157)
                                      ]),
                                      _createElementVNode("div", _hoisted_158, [
                                        _createElementVNode("div", _hoisted_159, [
                                          _createElementVNode("span", {
                                            onClick: $event => ($options.removeOption(frmIndex, optIndex)),
                                            "aria-label": "Consulter",
                                            class: "o-button-circle -button-circle-outline -button-circle-lg"
                                          }, _hoisted_162, 8 /* PROPS */, _hoisted_160)
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ]))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        ]))
                      }), 256 /* UNKEYED_FRAGMENT */)),
                      _createElementVNode("div", _hoisted_163, [
                        _createElementVNode("div", _hoisted_164, [
                          _createElementVNode("div", _hoisted_165, [
                            _withDirectives(_createElementVNode("input", {
                              class: "o-checkbox",
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => (($data.formData.acceptationPolitiques) = $event)),
                              id: "choix-5",
                              value: "Oui",
                              required: ""
                            }, null, 512 /* NEED_PATCH */), [
                              [_vModelCheckbox, $data.formData.acceptationPolitiques]
                            ]),
                            _hoisted_166
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            (!$data.success)
              ? (_openBlock(), _createElementBlock("div", _hoisted_167, [
                  _createElementVNode("span", {
                    onClick: _cache[15] || (_cache[15] = $event => ($options.addReservation())),
                    class: "o-button -button-outline"
                  }, _hoisted_170),
                  _createElementVNode("button", {
                    onClick: _cache[16] || (_cache[16] = _withModifiers($event => ($options.submit()), ["prevent"])),
                    class: "o-button",
                    type: "submit",
                    "aria-label": "Soumettre le formulaire"
                  }, _hoisted_174)
                ]))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
    ]),
    ($data.success)
      ? (_openBlock(), _createElementBlock("div", _hoisted_175, _hoisted_178))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}